
      document.addEventListener("DOMContentLoaded", function () {
      setTimeout(() => {
        const container = document.querySelector('.kl_reviews__list_container');
        const wrapper = container?.querySelector('div');
        const slides = container?.querySelectorAll('.kl_reviews__review_item');
    
        if (container && wrapper && slides.length > 0) {
          container.classList.add('swiper-container');
          wrapper.classList.add('swiper-wrapper');
          slides.forEach(slide => slide.classList.add('swiper-slide'));
    
          new Swiper('.kl_reviews__list_container', {
            slidesPerView: 1,
            spaceBetween: 20,
            loop: true,
            autoplay: {
                delay: 3000, // 3 seconds delay between slides
                disableOnInteraction: false, // keep autoplay after user interaction
              },
            breakpoints: {
                1920: {
                    slidesPerView: 4,
                    spaceBetween: 30
                },
                1028: {
                    slidesPerView: 3,
                    spaceBetween: 30
                },
                480: {
                    slidesPerView: 1,
                    spaceBetween: 10
                }
            },
          });
        }
      }, 2000);
    });

       document.addEventListener("DOMContentLoaded", function () {
        setTimeout(() => {
          const container = document.querySelector('.ingredient-container');
          const wrapper = container?.querySelector('.logo-list');
          const slides = container?.querySelectorAll('.logo-list__item');
      
          if (container && wrapper && slides.length > 0) {
            container.classList.add('swiper-container');
            wrapper.classList.add('swiper-wrapper');
            slides.forEach(slide => slide.classList.add('swiper-slide'));
      
            new Swiper('.ingredient-container', {
              slidesPerView: 4,
              spaceBetween: 20,
              loop: true,
              autoplay: {
                delay: 3000, // 3 seconds delay between slides
                disableOnInteraction: false, // keep autoplay after user interaction
              },
              breakpoints: {
                1920: {
                  slidesPerView: 7,
                  spaceBetween: 30
                },
                1028: {
                  slidesPerView: 7,
                  spaceBetween: 30
                },
                480: {
                  slidesPerView: 4,
                  spaceBetween: 10
                }
              },
            });
          }
        }, 2000);
      });

   document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    const container = document.querySelector('.ingredient-container1');
    const wrapper = container?.querySelector('.logo-list1');
    const slides = container?.querySelectorAll('.logo-list__item1');

    if (container && wrapper && slides.length > 0) {
      // Always add base Swiper classes for styling
      container.classList.add('swiper-container');
      wrapper.classList.add('swiper-wrapper');
      slides.forEach(slide => slide.classList.add('swiper-slide'));

      // ✅ Only initialize Swiper if more than 2 slides
      if (slides.length > 2) {
        new Swiper('.ingredient-container1', {
          loop: true,
          loopAdditionalSlides: 20,
          freeMode: true,
           
          freeModeMomentum: false,
          speed: 5000,
          autoplay: {
            delay: 0,
            disableOnInteraction: false,
          },
          allowTouchMove: false,
          slidesPerView: 4,
          spaceBetween: 30,
          breakpoints: {
            1920: {
              slidesPerView: 6,
              spaceBetween: 30
            },
            1028: {
              slidesPerView: 6,
              spaceBetween: 30
            },
            480: {
              slidesPerView: 4,
              spaceBetween: 10
            }
          }
        });
      } else {
        // Optional: visually disable Swiper look
        container.classList.add('swiper-disabled');
      }
    }
  }, 2000);
});

